let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4OdV1")).then(() => parcelRequire('lwLs9'));